import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { SchoolsAccordionTable } from '../../../components/SchoolsAccordionTable/SchoolsAccordionTable';
import { School } from '../../../components/SchoolsAccordionTable/types';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { ResultOf } from 'gql.tada';
import { propertyPageSchoolCollectionFragment } from '../../graphql/propertyPageQuery';
import { NearbySchoolsBrick } from './NearbySchoolsBricks';

type ApiPropertyPageSchool = NonNullable<
  NonNullable<
    NonNullable<ResultOf<typeof propertyPageSchoolCollectionFragment>['nearbySchools']>[number]
  >['schools']
>[number];

const mapApiSchoolToSchoolProp = (school: ApiPropertyPageSchool): School => {
  return {
    ...school,
    webLinks: school.webLinks
      ? school.webLinks.map((webLink) => ({
          ...webLink,
          variant: mapApiWeblinkVariantToLinkVariant(webLink.variant),
          iconInfo: webLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(webLink.iconInfo) : null,
        }))
      : [],
  };
};

export const NearbySchoolsBricksWithData: FunctionComponent = () => {
  const data = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!data?.nearbySchools) return null;

  return (
    <>
      {data.nearbySchools.map(
        ({ title, subtitleWithDynamicContent, schools, schoolFactHeader }) => {
          return (
            <NearbySchoolsBrick
              key={title}
              title={title}
              subtitleWithDynamicContent={mapDynamicContentItems(subtitleWithDynamicContent)}
            >
              <SchoolsAccordionTable
                schools={schools.map(mapApiSchoolToSchoolProp)}
                schoolFactHeader={schoolFactHeader}
              />
            </NearbySchoolsBrick>
          );
        },
      )}
    </>
  );
};
